import React from "react";
import { Cog8ToothIcon } from "@heroicons/react/24/outline";

const MaintananceComponent = () => {
  // let navigate = useNavigate();

  return (
    <div className="w-full h-screen h-screen-ios bg-gradient-to-r  -mt-12  from-bggradientleft to-bggradientright flex justify-center items-center flex-col text-textPrimary">
      <Cog8ToothIcon className="h-16 w-16 mb-4 animate-spin2 text-interaction  shrink-0" />

      <div className="flex  text-lg mb-2">Maintanance in progress</div>
      <div className="flex  font-extralight mb-4">Please try again later</div>
    </div>
  );
};

export default MaintananceComponent;
